module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_8011.38d0d4fa.png";